import { Component } from "@angular/core";
import { DeckMultiRowComponent } from "@ponder-features/user/decks/deck/deck-multi-row.component";
import { MagicDeckRowComponent } from "./magic-deck-row.component";
import { NgClass } from "@angular/common";

@Component({
    selector: "magic-deck-multi-row",
    imports: [MagicDeckRowComponent, NgClass],
    templateUrl: "./magic-deck-multi-row.component.html"
})
export class MagicDeckMultiRowComponent extends DeckMultiRowComponent {
    
}